import { Component } from '@angular/core';
import { ContentPageBaseComponent } from 'projects/shared/lib/components/standalone/content-page/content-page-base.component';

@Component({
    selector: 'app-content-page',
    templateUrl: './content-page.component.html',
    standalone: false
})
export class ContentPageComponent extends ContentPageBaseComponent { }
